import SpikeWaveformGrid from '../components/SpikeWaveformGrid';
import { WIDGET_DATA_CONTRACTS } from './dataContracts';

export const SPIKE_WAVEFORM_GRID = {
  id: 'spikeWaveformGrid', name: 'In-cluster Spike Waveforms',
  description: 'Individual spike cards with compact stacked channel waveforms',
  component: SpikeWaveformGrid, icon: '▦', category: 'visualization',
  defaultSize: { width: 820, height: 650 }, minWidth: 330, minHeight: 300,
  requiredData: ['clusters'], dataContract: WIDGET_DATA_CONTRACTS.spikeWaveformGrid, order: 28,
};
